import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class UnidadeMedidaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }
    
    validate(model, refs) {
        let validated = true;
        
        if (isNull(model.idprazopagto)) {
            refs.pacoteInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("error", 'msg-selecione-prazo-pagamento', true));
        }
        if (isNull(model.idtabpreco)) {
            refs.tabPrecoInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("error", 'msg-erro-desc-qtd-tabpreco', true));
        }
        return validated;
    }
}